exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.group-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-integrations/components/app-filter/installation-filter-button/InstallationFilterButton.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf","file":"InstallationFilterButton.vue","sourcesContent":["\n.group-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08961c88","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-integrations/components/app-filter/installation-filter-button/InstallationFilterButton.vue
// module id = PtVE
// module chunks = 72